import { DogPhoto } from "./dog-photo";

export function ProviderAvatar({ url }: { url: string | undefined }) {
    return (
        <span className="img-inset block size-10 shrink-0 overflow-hidden rounded-full bg-havanese">
            <DogPhoto url={url} size={80} logo="large" />
        </span>
    );
}
